import { mqttLogger } from '@hooks/mqtt/utils';

export const createTopicsKey = (topics: string[]): string => {
  return topics.slice().sort().join('|');
};

export const areTopicsEqual = (
  topicsA: string[],
  topicsB: string[],
): boolean => {
  if (topicsA.length !== topicsB.length) {
    return false;
  }
  const setA = new Set(topicsA);
  return topicsB.every((topic) => setA.has(topic));
};

export const createMultiTopicDebugLabel = (
  topics: string[],
  maxTopicsToShow = 5,
): string => {
  const visibleTopics = topics.slice(0, maxTopicsToShow).join(',');
  const suffix = topics.length > maxTopicsToShow ? '...' : '';
  return `multiTopic:[${visibleTopics}${suffix}]`;
};

export function validateTopic(topic: string, subscriberId: string): boolean {
  if (!topic || topic.trim() === '') {
    mqttLogger.error(
      `Invalid topic provided for subscription: ${JSON.stringify(topic)} (subscriber: ${subscriberId})`,
    );
    return false;
  }
  return true;
}

export function isValidUnsubscriptionTopic(
  topic: string,
  subscriberId: string,
): boolean {
  if (!topic || topic.trim() === '') {
    mqttLogger.error(
      `Invalid topic provided for unsubscription: ${JSON.stringify(topic)} (subscriber: ${subscriberId})`,
    );
    return false;
  }
  return true;
}
